module.exports = __webpack_public_path__ + "static/media/blog1_1.4301ff09.webp";